import script from "./ChartDataEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChartDataEditor.vue?vue&type=script&lang=ts&setup=true"

import "./ChartDataEditor.vue?vue&type=style&index=0&id=f7b59928&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7b59928"]])

export default __exports__